/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { GetStoreConfigResponse } from '@/account/types';
import { StoreConfigModel } from '../models';

export const transformStoreConfig = (
  response: GetStoreConfigResponse
): StoreConfigModel => {
  return {
    baseMediaUrl: response?.data?.storeConfig?.base_media_url,
    minLength: +response?.data?.storeConfig?.minimum_password_length || 3,
    requiredCharacterClasses:
      +response?.data?.storeConfig?.required_character_classes_number || 0,
    storeCode: response?.data?.storeConfig?.store_code ?? '',
  };
};
